// extracted by mini-css-extract-plugin
module.exports = {"form":"MultiplePerson_form__3Yo-x","addButton":"MultiplePerson_addButton__1R8zN","removeButton":"MultiplePerson_removeButton__bCO2t"};